import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import SubAdminDetails from '../SubAdmins/SubAdminDetails/SubAdminDetails'
import {UsersListWrapper} from './users-list/UsersList'
import UsersDetailsPage from './UsersDetailsPage'
import EditClasses from './EditClasses'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Classes Management',
    path: '/apps/classes',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ClassesManagement = () => {
  return (
    <Routes>
      {/* <Route element={<Outlet />}> */}
      <Route
        path='/:p'
        element={
          <>
            <PageTitle breadcrumbs={usersBreadcrumbs}>Classes Management</PageTitle>
            <UsersListWrapper />
          </>
        }
      />
      <Route path='classes/details-page' element={<UsersDetailsPage />} />

      <Route path='classes/edit' element={<EditClasses />} />

      {/* </Route> */}
      <Route element={<Navigate to='/apps/classes' />} />
    </Routes>
  )
}

export default ClassesManagement
